import { canUseDOM } from '@ps/web-core-utils';

// the map is from PYR-92093 document 'WebCollect Technical Guide 2019 Q1 (1).pdf' DO_AUTHENTICATE
enum WindowSizeMapToNumber {
  '250x400' = '1',
  '390x400' = '2',
  '500x600' = '3',
  '600x400' = '4',
  fullPage = '5'
}

export enum ChallengeWindowSize {
  PSP3DS2 = '500x600', // {width: 500, height: 600};
  PSP3DS2FullPage = 'fullPage'
}

export const browserExtraInfo = canUseDOM
  ? {
      clientBrowserLocale: navigator.language,
      clientChallengeWinSize: WindowSizeMapToNumber[ChallengeWindowSize.PSP3DS2],
      clientTzOffsetInMin: `${new Date().getTimezoneOffset()}`,
      clientUserAgent: navigator.userAgent,
      clientJavaEnabled: navigator.javaEnabled(),
      clientJavascriptEnabled: true,
      clientScreenColorDepth: window.screen.colorDepth,
      clientScreenHeight: window.screen.height,
      clientScreenWidth: window.screen.width
    }
  : null;
